export enum AdminPanelName {
  Create = 'create',
  Event = 'event',
  EventList = 'event_list',
  Home = 'home',
  Page = 'page',
  PageList = 'page_list',
  Place = 'place',
  PlaceList = 'place_list',
  SiteSettings = 'site_settings',
  SiteTheme = 'site_theme',
  Waiting = 'waiting',
}
